import {
  ByIdPayload,
  ChangeParamsByIdPayload,
  FailByIdPayload,
  ListReducerTypes,
  NormalizedList,
  PayloadAction,
  SuccessByIdPayload,
  uniqueActionType
} from '@industi/ngx-common';
import { SymfonyPaginationParams } from '../../../symfony/list/models/symfony-pagination-params';

export const DictionaryAcquisitionLoadListActionTypes: ListReducerTypes = {
  request: uniqueActionType('[dictionary/acquisition] Load list'),
  requestFail: uniqueActionType('[dictionary/acquisition] Load list fail'),
  requestSuccess: uniqueActionType('[dictionary/acquisition] Load list success'),
  requestClear: uniqueActionType('[dictionary/acquisition] Load list clear'),
  changeParams: uniqueActionType('[dictionary/acquisition] Load list change params'),
  clearParams: uniqueActionType('[dictionary/acquisition] Load list clear params'),
  clearIds: uniqueActionType('[dictionary/acquisition] Load list clear ids')
};

export class DictionaryAcquisitionLoadListAction implements PayloadAction {
  readonly type = DictionaryAcquisitionLoadListActionTypes.request;

  constructor(public payload: ByIdPayload) {
  }
}

export class DictionaryAcquisitionLoadListFailAction implements PayloadAction {
  readonly type = DictionaryAcquisitionLoadListActionTypes.requestFail;

  constructor(public payload: FailByIdPayload) {
  }
}

export class DictionaryAcquisitionLoadListSuccessAction implements PayloadAction {
  readonly type = DictionaryAcquisitionLoadListActionTypes.requestSuccess;

  constructor(public payload: SuccessByIdPayload<NormalizedList>) {
  }
}

export class DictionaryAcquisitionLoadListClearAction implements PayloadAction {
  readonly type = DictionaryAcquisitionLoadListActionTypes.requestClear;

  constructor(public payload: ByIdPayload) {
  }
}

export class DictionaryAcquisitionLoadListChangeParamsAction implements PayloadAction {
  readonly type = DictionaryAcquisitionLoadListActionTypes.changeParams;

  constructor(public payload: ChangeParamsByIdPayload<SymfonyPaginationParams>) {
  }
}

export class DictionaryAcquisitionLoadListClearParamsAction implements PayloadAction {
  readonly type = DictionaryAcquisitionLoadListActionTypes.clearParams;

  constructor(public payload: ByIdPayload) {
  }
}

export class DictionaryAcquisitionLoadListClearIdsAction implements PayloadAction {
  readonly type = DictionaryAcquisitionLoadListActionTypes.clearIds;

  constructor(public payload: ByIdPayload) {
  }
}
